import { render, staticRenderFns } from "./pagination.vue?vue&type=template&id=63dd327d&scoped=true"
import script from "./pagination.vue?vue&type=script&lang=ts"
export * from "./pagination.vue?vue&type=script&lang=ts"
import style0 from "./pagination.vue?vue&type=style&index=0&id=63dd327d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63dd327d",
  null
  
)

export default component.exports